import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { of } from 'rxjs';
import { AuthService } from '@cumlaude/shared-authentication';

export const developerGuard: CanMatchFn = () => {
	const authService = inject(AuthService);
	if (!authService.isLoggedIn()) {
		return of(true); // auth-guard onthoudt route en doet de redirect
	}

	if (!authService.isUserDeveloper()) {
		return of(false); // Alleen developers mogen deze routes zien
	}

	return of(true);
};
